import TooltipContainer from './ColorTooltip.styles';

export const ColorTooltip = ({ label = 'Pas hier de kleur aan' }: { label?: string }) => (
  <TooltipContainer>{label}</TooltipContainer>
);
